import { isTouchable, isWeb, useDidFinishSSR, useMedia } from "tamagui";

// True when the adaptive Dropdown shows its sheet, not the popover. Native
// only — web (including iOS Safari) stays on the popover so a Combobox inside
// a Dialog remains tappable. Radix Dialog sets `pointer-events: none` on
// `body`; a Sheet portals outside `Dialog.Content` and paints but swallows
// no taps. `useDidFinishSSR()` defers the `isTouchable` read until hydration
// so the server and first client paint agree (popover).
export const useInSheet = (): boolean => {
  const hydrated = useDidFinishSSR();
  const sm = useMedia().sm;
  return !isWeb && hydrated && sm && isTouchable;
};

export const useUsesSheet = (shouldUseSheet = true): boolean => {
  const inSheet = useInSheet();
  return shouldUseSheet && inSheet;
};
